import Component from '@bythepixel/component-loader';

export default class StickyScrollUpNavigation extends Component {
  static loaderPriority = 'in-view';
  static selector = '[data-comp-sticky-scroll-up-navigation]';

  constructor(containerEl) {
    super(containerEl);
    this.activeClass = 'sticky-scroll-up-navigation--active';
    this.parentElement = this.$container.parentElement;
    this.optionLinks = this.$container.querySelectorAll('[data-option-link]');
    this.selectList = this.$container.querySelector('[data-select-list]');
    this.init();
  }

  init() {
    this.addScrollListener();
    this.addSelectChangeListener();
  }

  addScrollListener() {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > this.parentElement.offsetTop) {
          if (currentScroll > 0 && lastScroll <= currentScroll) {
            lastScroll = currentScroll;
            if (this.$container.classList.contains(this.activeClass)) {
              this.$container.classList.remove(this.activeClass);
            }
          } else {
            lastScroll = currentScroll;
            if (!this.$container.classList.contains(this.activeClass)) {
              this.$container.classList.add(this.activeClass);
            }
          }
        } else if (this.$container.classList.contains(this.activeClass)) {
          this.$container.classList.remove(this.activeClass);
        }

        this.changeSelectedOptionOnScrollListener();
      });
    });
  }

  changeSelectedOptionOnScrollListener() {
    const currentScroll = document.documentElement.scrollTop;
    this.optionLinks.forEach((optionLink, index) => {
      const section = document.querySelector(optionLink.getAttribute('href'));
      const parentTop = section.parentElement.offsetTop;
      const sectionLinkTop = section.offsetTop + parentTop;
      const sectionLinkBottom = sectionLinkTop + section.offsetHeight;
      if (currentScroll > sectionLinkTop && sectionLinkBottom > currentScroll) {
        this.selectList.selectedIndex = index;
      }
    });
  }

  addSelectChangeListener() {
    this.selectList.addEventListener('change', () => {
      const linkHash = this.selectList.options[this.selectList.selectedIndex].getAttribute('href');
      window.location.hash = linkHash;
    });
  }
}
